import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeContentPageAlternative'
 * @name TypeContentPageAlternativeFields
 * @type {TypeContentPageAlternativeFields}
 * @memberof TypeContentPageAlternative
 */
export interface TypeContentPageAlternativeFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized false
     */
    header: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'image' (Image)
     * @name Image
     * @localized false
     */
    image?: EntryFieldTypes.AssetLink;
}

/**
 * Entry skeleton type definition for content type 'contentPageAlternative' (Content Page Header Alternative)
 * @name TypeContentPageAlternativeSkeleton
 * @type {TypeContentPageAlternativeSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T19:50:22.857Z
 * @version 5
 */
export type TypeContentPageAlternativeSkeleton = EntrySkeletonType<TypeContentPageAlternativeFields, "contentPageAlternative">;
/**
 * Entry type definition for content type 'contentPageAlternative' (Content Page Header Alternative)
 * @name TypeContentPageAlternative
 * @type {TypeContentPageAlternative}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T19:50:22.857Z
 * @version 5
 */
export type TypeContentPageAlternative<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeContentPageAlternativeSkeleton, Modifiers, Locales>;

export function isTypeContentPageAlternative<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeContentPageAlternative<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'contentPageAlternative'
}
